export function draw(
  absolutePoint,
  status,
  currentItemView,
) {
  if (status !== 'drawing') return false

  //change width and height of current itemView
  currentItemView.boundary.width = absolutePoint.x - currentItemView.boundary.x
  currentItemView.boundary.height = absolutePoint.y - currentItemView.boundary.y

  //stop checking of interations
  return true
}



// WEBPACK FOOTER //
// ./src/drawing/core/mouseMove/draw.js